import { Component, Input, Output, OnInit, OnChanges, SimpleChanges, EventEmitter } from '@angular/core';
import { GaFormlyService, IExtraFieldConfigurationObject } from '../../../shared/formly/ga-formly.service';
import { GaValidateService } from '../../../shared/formly/ga-validate.service';
import { WebshopAccessSettingsDataService } from './webshop-access-settings-data.service';
import { UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'email-tester-popup',
  template: `
		<div class="message-dialog">
			<div class="modal-header"><h4 class="modal-title">Test Email Suffix</h4></div>
			<div class="modal-body">
				<div class="form-horizontal">
          <formly [form]="form" [fields]="fields" [model]="model"></formly>
        </div>
			</div>
			
			<div class="modal-footer footer-margin">
				<button type="button" class="btn" (click)="cancel()" [disabled]="busy">Cancel</button>
				<button type="button" class="btn btn-success" (click)="testEmail()" [busyButton]="busy">Submit</button>
			</div>
		</div>
	`
})
export class EmailTesterPopupComponent implements OnInit, OnChanges {
  @Input() webshopId:number;
  @Input() emailSuffix:string;
  @Output() public onSuccess:EventEmitter<string> = new EventEmitter();
  @Output() public onCancel:EventEmitter<void> = new EventEmitter();

  public form:UntypedFormGroup = new UntypedFormGroup({});

  public model:{ email:string; } = {
    email: undefined
  };

  public fields:IExtraFieldConfigurationObject[];
  public busy:boolean;

  constructor(
    private formlyService:GaFormlyService,
    private validateService:GaValidateService,
    private webshopAccessSettingsDataService:WebshopAccessSettingsDataService
  ) {
    /**/
  }

  public ngOnInit():void {
    this.fields = this.createFields();
  }

  public ngOnChanges(changesObj:SimpleChanges):void {
    if (changesObj.webshopId && changesObj.webshopId.currentValue) {
      this.webshopId = changesObj.webshopId.currentValue;
    }

    if (changesObj.emailSuffix && changesObj.emailSuffix.currentValue) {
      this.emailSuffix = changesObj.emailSuffix.currentValue;
    }
  }

  private createFields():IExtraFieldConfigurationObject[] {
    return [
      this.formlyService.anInput('email', 'Email')
        .isRequired()
        .build()
    ];
  }

  public testEmail():void {
    this.validateService.validateFields(this.fields, this.model, true)
      .then(() => {
        this.busy = true;
        this.webshopAccessSettingsDataService.testCompanyEmailSuffix(this.webshopId, {
          email: this.model.email,
          emailSuffix: this.emailSuffix
        })
          .then((response:string) => {
            this.onSuccess.emit(response);
          })
          .finally(() => {
            this.busy = false;
          });
      });
  }

  public cancel():void {
    this.onCancel.emit();
  }
}